export const isLeadExternalEndpoint = (url = '') => /\/nmx-api-proxy\/nmx\/ms-form-proxy\/(lead|lead-v2|immediate-match)(\/|$|\?)/.test(url);
